import axios from 'axios';

import accessLocalStorage from './accessLocalStorage';

const { 
  REACT_APP_HOST,
  REACT_APP_API_USER_AST,
  REACT_APP_API_PASS_AST,
} = process.env

export const clickToCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/calls/click`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const cancelClickToCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/cancel-click`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const trasferCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/transfer`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const cancelTrasferCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/cancel-transfer`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const clickToSpy = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/spy`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

//////////////////////// USERS /////////////////////////
export const requestToken = async (userData, ip) => {
  try {
    const token = await axios.post(`${ip}api/login`, userData);
    return token;
  } catch (error) {
    return error;
  }
}

export const registerUser = async (userData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.post(`${ipRequest}api/login/register`, userData,  { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error.response.status;
  }
}

export const updateUser = async (userData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.post(`${ipRequest}api/login/update`, userData,  { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error.response.status;
  }
}

export const listUsers = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.get(`${ipRequest}api/login`,  { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error.response.status;
  }
}

export const deleteUser = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.post(`${ipRequest}api/login/delete`, data, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error.response.status;
  }
}

export const userByEmail = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.post(`${ipRequest}api/login/email`, data, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error.response.status;
  }
}

export const fetchEndpoints = async () => {
  try {
    const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
    const request = await fetch(`${ipRequest}ari/endpoints?api_key=${REACT_APP_API_USER_AST}:${REACT_APP_API_PASS_AST}`);
    const endpoints = await request.json();
    return endpoints;
  } catch (error) {
    console.log(error);
  }
};

export const fetchCallsDataBase = async (day) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db`, day, { headers: { Authorization: token } });
    return response.data.rows;
  } catch (error) {
    return error;
  }
}

export const fetchCallsByDateDB = async (days) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/by-date`, days, { headers: { Authorization: token } });
    return response.data.rows;
  } catch (error) {
    return error;
  }
}

export const fetchCallsAnalistas = async (id) => {
  try {
    const request = await fetch(`${REACT_APP_HOST}/api/analistas/${id}`);
    const callsAnalist = await request.json();
    return callsAnalist;
  } catch (error) {
    console.log(error);
  }
};

export const fetchRecCall = async (id) => {
  try {
    const request = await fetch(`${REACT_APP_HOST}/api/download/file/${id}`);
    return request.url;
  } catch (error) {
    console.log(error);
  }
};

export const fetchCallOnDay = async (id) => {
  try {
    const request = await fetch(`${REACT_APP_HOST}/api/dbday/${id}`);
    const calls = await request.json();
    return calls;
  } catch (error) {
    console.log(error);
  }
};

export const fetchDataReport = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant; // Usar o tenant atual (após pivot se aplicável) // Usar o tenant atual (após pivot se aplicável)
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/report`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchSectors = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/db/report/sector`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchDataReportList = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant; // Usar o tenant atual (após pivot se aplicável)
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/report/list`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchRowsChartSectors = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant; // Usar o tenant atual (após pivot se aplicável) // Usar o tenant atual (após pivot se aplicável)
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/report/list-sector-chart`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportReportGenerate = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant; // Usar o tenant atual (após pivot se aplicável)

  try {
    const response = await axios
      .post(`${ipRequest}api/report/export`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportReportGenerateLogs = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant; // Usar o tenant atual (após pivot se aplicável)
  
  try {
    const response = await axios
      .post(`${ipRequest}api/report/export-logs`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportReportDownload = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/report/download-stats`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

////////// API TRUNKS /////////
export const exportCreateTrunks = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/config/trunks/create`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createInboundDispatcherTrunk = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/trunks/create-inbound-dispatcher`,
      dataRequest,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const updateInboundDispatcherIps = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/trunks/update-inbound-dispatcher`,
      dataRequest,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const readInboundDispatcherIps = async (provider) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/trunks/inbound-dispatcher-ips/${encodeURIComponent(provider)}`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const listInboundDispatchers = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/trunks/inbound-dispatchers`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const exportSelectAllTrunks = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/trunks`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectAllTrunksWithInterconnection = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/trunks/with-interconnection`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectTrunkById = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/trunks/id`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectTrunkByRealNumber = async (realNumber) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    // Validação básica
    if (!realNumber || realNumber.trim() === '') {
      throw new Error('Número real é obrigatório');
    }

    const encodedRealNumber = encodeURIComponent(realNumber.trim());
    const response = await axios
      .get(`${ipRequest}api/config/trunks/real-number/${encodedRealNumber}`, { 
        headers: { Authorization: token } 
      });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar trunk por número real:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Erro ao buscar trunk',
      data: []
    };
  }
};

export const checkTrunkUsage = async (trunkName) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    if (!trunkName || trunkName.trim() === '') {
      throw new Error('Nome do trunk é obrigatório');
    }

    const encodedTrunkName = encodeURIComponent(trunkName.trim());
    const response = await axios
      .get(`${ipRequest}api/config/trunks/usage/${encodedTrunkName}`, { 
        headers: { Authorization: token } 
      });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar uso do trunk:', error);
    return {
      success: false,
      hasConfigurations: false,
      incomingCount: 0,
      outboundCount: 0,
      totalCount: 0,
      message: error.response?.data?.message || error.message || 'Erro ao verificar uso do trunk'
    };
  }
};

export const exportUpdateTrunks = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/trunks/update`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error.response?.data || error;
  }
};

export const exportDeleteTrunks = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/trunks/delete`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

////////// API ENDPOINTS /////////
export const exportCreateEndpoints = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/endpoints/create`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectAllEndpoints = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/endpoints`, { headers: { Authorization: token } })
    return response.data;
  } catch (error) {
    return console.error(error);
  }
};

export const exportSelectEndpointsById = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/endpoints/id`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportUpdateEndpoints = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/endpoints/update`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportDeleteEndpoints = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/config/endpoints/delete`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getWebrtcCredentials = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .get(`${ipRequest}api/config/endpoints/webrtc-credentials`, { headers: { Authorization: token } });
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { error: error.message };
    return { status, data };
  }
};

////////// API QUEUES /////////
export const exportCreateQueues = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/create`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectAllQueues = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/queues`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueuesByName = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/name`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportUpdateQueues = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/update`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportDeleteQueues = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/delete`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

////////// API MEMBER QUEUES /////////
export const exportCreateQueueMembers = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/create`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectAllQueueMembers = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/queues/members`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueueMemberByName = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/name`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueueMemberByEndpoint = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/endpoint`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueueMemberById = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/id`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportUpdateQueueMember = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/update`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportDeleteQueueMember = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/delete`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

////////// API MOH /////////
export const getMusicOnHoldData = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  try {
    const response = await axios
      .get(`//${ipClean}/api/config/moh`, { headers: { Authorization: token }, params: dataRequest });
    return response;
  } catch (error) {
    return error;
  }
};

export const exportSelectAllMohs = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/moh`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const exportSelectMohsByName = async (name) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/moh/name/${name}`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const exportDeleteMohs = async (name) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .delete(`${ipRequest}api/config/moh/delete/${name}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

////////// API CHANGE IP /////////
export const readInterfaces = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/ip/interfaces`, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

export const changeIpInterfaces = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/config/ip/change`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

// ---------------------------------------------------------------------
// Commit-confirm de troca de IP (Gap 2)
// ---------------------------------------------------------------------
export const stageIpChange = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/ip/stage`,
      dataRequest,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const confirmIpChange = async (token) => {
  const { token: authToken, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/ip/confirm`,
      { token },
      { headers: { Authorization: authToken } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const rollbackIpChange = async (token) => {
  const { token: authToken, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/ip/rollback`,
      { token },
      { headers: { Authorization: authToken } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const ipChangeHealth = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/ip/health`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

// ---------------------------------------------------------------------
// PJSIP Transports (master-only POST) — edita local_net /
// external_media_address / external_signaling_address nos 4 transports
// (udp/tcp/ws/wss) do /etc/asterisk/pjsip.conf.
// ---------------------------------------------------------------------
export const getPjsipTransports = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/pjsip-transports`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const updatePjsipTransports = async (payload) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/pjsip-transports`,
      payload,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

////////// API CHANGE ROUTES /////////
export const readIpRoutes = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .get(`${ipRequest}api/config/ip/routes`, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

export const readManagedRoutes = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .get(`${ipRequest}api/config/ip/routes/managed`, { headers: { Authorization: token } });
    return { ok: true, data: response.data };
  } catch (error) {
    const data = error.response && error.response.data ? error.response.data : null;
    return {
      ok: false,
      status: error.response ? error.response.status : 0,
      message: (data && data.message) || error.message || 'Falha ao listar rotas gerenciadas.',
      code: data && data.code,
    };
  }
};

export const changeIpRoutes = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .post(`${ipRequest}api/config/ip/routes`, dataRequest, { headers: { Authorization: token } });
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    const data = error.response && error.response.data ? error.response.data : null;
    return {
      ok: false,
      status: error.response ? error.response.status : 0,
      message: (data && data.message) || error.message || 'Falha ao criar rota.',
      code: data && data.code,
      details: data && data.details,
      errors: data && data.errors,
    };
  }
};

export const deleteIpRoute = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .delete(`${ipRequest}api/config/ip/routes/${ encodeURIComponent(id) }`, { headers: { Authorization: token } });
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    const data = error.response && error.response.data ? error.response.data : null;
    return {
      ok: false,
      status: error.response ? error.response.status : 0,
      message: (data && data.message) || error.message || 'Falha ao remover rota.',
      code: data && data.code,
    };
  }
};

////////// API SYSTEM /////////
export const sendRebootSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/system/reboot`, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

export const sendRegisterTrunkSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/system/register`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const applyDialplanSystem = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/system/dialplan`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const loggerSipEnableSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/system/logs`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};


export const loggerSipDownloadSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/system/logs/download/pcap`, { headers: { Authorization: token }, responseType: 'blob' });
    return response;
  } catch (error) {
    return error;
  }
};

////////// API DIALPLAN /////////
export const internalDialplan = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const entranceDialplan = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/dialplan/entrance`, dataRequest, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

export const externalDialplan = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/dialplan/external`, dataRequest, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

////////// API CONTACTS /////////
export const readContacts = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .get(`//${ipClean}/contacts/read`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createContact = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .post(`//${ipClean}/contacts/contactcreate`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createPhone = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .post(`//${ipClean}/contacts/phonecreate`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getContatById = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .post(`//${ipClean}/contacts/id`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getContatByAlias = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .post(`//${ipClean}/contacts/alias`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getContatByDoc = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .post(`//${ipClean}/contacts/doc`, dataRequest,{ headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteContact = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      .post(`//${ipClean}/contacts/contactdel`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const sendPingAndTracertSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const { command, ip } = dataRequest;
    const response = await fetch(`//${ipClean}/api/system/command?command=${command}&ip=${encodeURIComponent(ip)}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const sendReloadAsteriskSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const { command } = dataRequest;
    const response = await fetch(`//${ipClean}/api/system/command/asterisk?command=${command}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const deletePhone = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      .post(`//${ipClean}/contacts/phonedel`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateContact = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .post(`//${ipClean}/contacts/update`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updatePhone = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      // .post(`${ipRequest}api/config/dialplan/internal`, dataRequest, { headers: { Authorization: token } });
      .post(`//${ipClean}/contacts/phone/update`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getDataDashboard = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant; // Usar o tenant atual (após pivot se aplicável)
  
  try {
    const response = await axios
      .post(`//${ipClean}/rpt/dashboard`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const sendDataMohGenerate = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  console.log(dataRequest);
  try {
    const response = await axios
      .post(`//${ipClean}/api/config/moh`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const sendDataMohUpdate = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  try {
    const response = await axios
      .put(`//${ipClean}/api/config/moh/update`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

// ======================== ÁUDIO SERVICES ========================

/**
 * Lista áudios por tenant e tipo
 * @param {Object} params - Parâmetros da consulta
 * @param {string} params.tenant - Tenant para filtrar
 * @param {string} params.type - Tipo de áudio (opcional)
 * @returns {Promise} Response da API
 */
export const listAudiosByTenant = async (params = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/audios/list`);
    
    // Adicionar parâmetros à URL
    if (params.tenant) url.searchParams.append('tenant', params.tenant);
    if (params.type) url.searchParams.append('type', params.type);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao listar áudios:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao listar áudios'
    };
  }
};

/**
 * Verifica se um arquivo de áudio existe
 * @param {Object} params - Parâmetros da verificação
 * @param {string} params.tenant - Tenant do arquivo
 * @param {string} params.type - Tipo do arquivo
 * @param {string} params.file - Nome do arquivo
 * @returns {Promise} Response da API
 */
export const checkAudioExists = async (params) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/audios/check`);
    
    // Adicionar parâmetros à URL
    url.searchParams.append('tenant', params.tenant);
    url.searchParams.append('type', params.type);
    url.searchParams.append('file', params.file);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar áudio:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao verificar áudio'
    };
  }
};

// ======================== INTERNAL CONFIGS ========================

/**
 * Cria uma nova configuração interna
 * @param {Object} configData - Dados da configuração
 * @returns {Promise} Response da API
 */
export const createInternalConfig = async (configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.post(
      `${ipRequest}api/config/dialplan/internals/configs`,
      configData,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao criar configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.response?.data?.message || 'Erro ao criar configuração',
      details: error.response?.data?.details
    };
  }
};

/**
 * Lista configurações internas
 * @param {Object} filters - Filtros da consulta
 * @returns {Promise} Response da API
 */
export const getAllInternalConfigs = async (filters = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/internals/configs`);
    
    // Adicionar filtros à URL
    if (filters.tenant) url.searchParams.append('tenant', filters.tenant);
    if (filters.active_only !== undefined) url.searchParams.append('active_only', filters.active_only);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao listar configurações internas:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao listar configurações'
    };
  }
};

/**
 * Busca uma configuração interna por ID
 * @param {number} configId - ID da configuração
 * @returns {Promise} Response da API
 */
export const getInternalConfigById = async (configId) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.get(
      `${ipRequest}api/config/dialplan/internals/configs/${configId}`,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar configuração'
    };
  }
};

/**
 * Atualiza uma configuração interna
 * @param {number} configId - ID da configuração
 * @param {Object} configData - Dados atualizados
 * @returns {Promise} Response da API
 */
export const updateInternalConfig = async (configId, configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.put(
      `${ipRequest}api/config/dialplan/internals/configs/${configId}`,
      configData,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.response?.data?.message || 'Erro ao atualizar configuração',
      details: error.response?.data?.details
    };
  }
};

/**
 * Remove uma configuração interna
 * @param {number} configId - ID da configuração
 * @returns {Promise} Response da API
 */
export const deleteInternalConfig = async (configId) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.delete(
      `${ipRequest}api/config/dialplan/internals/configs/${configId}`,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao remover configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao remover configuração'
    };
  }
};

/**
 * Busca estatísticas de configurações internas
 * @param {string} tenant - Tenant para filtrar (opcional)
 * @returns {Promise} Response da API
 */
export const getInternalStatistics = async (tenant = null) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/internals/statistics`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estatísticas:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar estatísticas'
    };
  }
};

/**
 * Busca dados completos por tenant
 * @param {string} tenant - Tenant para buscar
 * @returns {Promise} Response da API
 */
export const getInternalDataByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/internals/tenant`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar dados do tenant:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar dados do tenant'
    };
  }
};

/**
 * Busca contextos disponíveis para um tenant
 * @param {string} tenant - Tenant para buscar contextos
 * @returns {Promise} Response da API
 */
export const getContextsByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/contexts`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar contextos:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar contextos'
    };
  }
};

/**
 * Busca contextos filtrados por tenant (apenas da tabela contexts)
 * @param {string} tenant - Tenant para buscar contextos
 * @returns {Promise} Response da API
 */
export const getContextsFilteredByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/contexts-filtered`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar contextos filtrados:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar contextos filtrados'
    };
  }
};

////////// API INTEGRATIONS /////////
export const createIntegration = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/integrations`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getAllIntegrations = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getIntegrationById = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations/${id}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getIntegrationsByAccountcode = async (accountcode) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations/accountcode/${accountcode}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getIntegrationsByType = async (type) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations/type/${type}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateIntegration = async (id, dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .put(`${ipRequest}api/integrations/${id}`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteIntegration = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .delete(`${ipRequest}api/integrations/${id}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

// ======================== OUTBOUND CALL CONFIGS ========================

/**
 * Cria uma nova configuração de chamada de saída
 * @param {Object} configData - Dados da configuração
 * @returns {Promise} Response da API
 */
export const createOutboundConfig = async (configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.post(
      `${ipRequest}api/config/outbound/configs`,
      configData,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao criar configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao criar configuração',
      message: error.response?.data?.message || error.message
    };
  }
};

/**
 * Lista todas as configurações de chamadas de saída
 * @param {Object} filters - Filtros de busca
 * @returns {Promise} Response da API
 */
export const getAllOutboundConfigs = async (filters = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    // Construir URL com parâmetros
    const url = new URL(`${ipRequest}api/config/outbound/configs`);
    
    if (filters.tenant) url.searchParams.append('tenant', filters.tenant);
    if (filters.callType) url.searchParams.append('callType', filters.callType);
    if (filters.activeOnly !== undefined) url.searchParams.append('activeOnly', filters.activeOnly);
    
    const response = await axios.get(url.toString(), {
      headers: { Authorization: token }
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao listar configurações outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao listar configurações',
      data: []
    };
  }
};

/**
 * Busca configuração de chamada de saída por ID
 * @param {number} id - ID da configuração
 * @returns {Promise} Response da API
 */
export const getOutboundConfigById = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.get(
      `${ipRequest}api/config/outbound/configs/${id}`,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar configuração',
      data: null
    };
  }
};

/**
 * Atualiza configuração de chamada de saída
 * @param {number} id - ID da configuração
 * @param {Object} configData - Dados atualizados
 * @returns {Promise} Response da API
 */
export const updateOutboundConfig = async (id, configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.put(
      `${ipRequest}api/config/outbound/configs/${id}`,
      configData,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao atualizar configuração',
      message: error.response?.data?.message || error.message
    };
  }
};

/**
 * Remove configuração de chamada de saída
 * @param {number} id - ID da configuração
 * @returns {Promise} Response da API
 */
export const deleteOutboundConfig = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.delete(
      `${ipRequest}api/config/outbound/configs/${id}`,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao remover configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao remover configuração',
      message: error.response?.data?.message || error.message
    };
  }
};

/**
 * Busca estatísticas de configurações por tenant
 * @param {string} tenant - Tenant (opcional para root)
 * @returns {Promise} Response da API
 */
export const getOutboundStatistics = async (tenant = null) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/outbound/statistics`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), {
      headers: { Authorization: token }
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estatísticas outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar estatísticas',
      data: []
    };
  }
};

/**
 * Lista troncos disponíveis para um tenant
 * @param {string} tenant - Tenant (opcional para root)
 * @returns {Promise} Response da API
 */
export const getAvailableTrunks = async (tenant = null) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/outbound/trunks`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), {
      headers: { Authorization: token }
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar troncos disponíveis:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar troncos',
      data: []
    };
  }
};
